<template>
    <div class="field-wrapper" :class="classes">
        <input
            :type="type"
            v-bind="$attrs"
            :readonly="readonly"
            v-on="inputListeners"
            class="form-control"
            :class="{ 'form-error': error }"
            :value="value"
            @input="$emit('input', $event.target.value)"
        />
        <div class="field-placeholder">{{ label }} <span class="text-danger" v-if="isRequired">*</span></div>
    </div>
</template>
<script>
export default {
    name: 'input-text',
    inheritAttrs: false,
    props: {
        value: [String, Number, Array],
        isRequired: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            required: false,
            default: ''
        },
        label: {
            type: String,
            required: false,
            default: ''
        },
        type: {
            type: [String, Number],
            required: false
        },
        classes: {
            type: [String, Object],
            required: false,
            default: function () {
                return '';
            }
        },
        rows: {
            type: Number,
            required: false,
            default: 2
        },
        textAppend: {
            type: String,
            required: false,
            default: null
        },
        isShowPassword: {
            type: Boolean,
            required: false,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            rows1: this.rows || 1,
            value1: '',
            isFocused: false,
            message: null,
            maxLength: null
        };
    },
    computed: {
        listeners() {
            return {
                ...this.$listeners,
                blur: this.onBlur,
                focus: this.onFocus
            };
        },
        mergedProps() {
            return {
                ...this.$attrs,
                ...this.$props
            };
        },
        inputListeners: function () {
            let vm = this;
            return Object.assign({}, this.$listeners, {
                input: function (event) {
                    vm.$emit('input', event.target.value);
                }
            });
        }
    },
    methods: {
        changeInput(e) {
            if (e.target.value.length <= this.maxLength) {
                this.$emit('input', e.target.value);
            } else {
                e.target.value = this.value;
                this.$emit('input', this.value);
            }
        },
        onBlur() {
            this.isFocused = false;
        },
        onFocus() {
            this.isFocused = true;
        }
    }
};
</script>
<style lang="scss">
.field-wrapper {
    &.text-read-only {
        input {
            &:read-only {
                color: #7a6d0a;
                font-style: italic;
                font-size: 14px;
                font-family: Helvetica;
            }
        }
    }
    .form-error {
        border-color: #dc3545 !important;
        padding-right: calc(1.5em + 0.75rem);
        background-repeat: no-repeat;
        background-position: right calc(0.375em + 0.1875rem) center;
        background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
        background-color: #fedede;
    }
}
</style>
